import createRoute      from '@widesk-ui/tools/createRoute';
import PeriodGroupModel from '@models/shop/PeriodGroupModel';

export default createRoute.splitView('/entertainments/:entertainmentId/period_groups', 'shop', 'PeriodGroupSplitView', PeriodGroupModel.localize('plural'));
